const tableHeaders = {
	//고객사 페이지 - 고객
	clientTableHeader: [
		{ text: '고객사 ID', headerKey: 'id' },
		{ text: '상위 고객사', headerKey: 'parent.name', type: 'link' },
		{ text: '이름', headerKey: 'name' },
		{ text: '사업자번호', headerKey: 'bizNum' },
		{ text: '연락처', headerKey: 'contact.phone', type: 'phone' },
		{ text: '담당자', headerKey: 'manager.name', type: 'user' },
		{ text: '등록일', headerKey: 'createDatetime', type: 'date' },
		{ text: '최근 진행 업무', headerKey: 'project.code', type: 'id' },
		{ text: '최근 업무 진행일', headerKey: 'createDatetime', type: 'date' }
	],
	//고객사 - 담당자
	clientManagerHeader: [
		{ key: 'selected', label: ' ' },
		{ key: 'name', label: '이름' },
		{ key: 'contact', label: '연락처' },
		{ key: 'phone', label: '휴대폰 번호' },
		{ key: 'contact', label: '팩스 번호' },
		{ key: 'email', label: '이메일' }
	],
	//고객사 상세 - 상위고객 상세 검색
	searchClientTableHeader: [
		{ text: '고객사 ID', headerKey: 'id' },
		{ text: '상위 고객사', headerKey: 'parent.name', type: 'link' },
		{ text: '이름', headerKey: 'name' },
		{ text: '사업자번호', headerKey: 'bizNum' },
		{ text: '연락처', headerKey: 'contact.phone', type: 'phone' },
		{ text: '담당자', headerKey: 'manager.name', type: 'user' }
	],
	//대시보드 - 이슈보드
	dashboardIssueTableHeader: [
		{ text: '업무 ID', headerKey: 'id' },
		{ text: '내용', headerKey: 'content' },
		{ text: '작성자', headerKey: 'manager' },
		{ text: '작성일시', headerKey: 'createDatetime', type: 'date' },
		{ text: '상태', headerKey: 'status', type: 'select-status' }
	],
	//대시보드 - 내 업무
	dashboardMyProjectTableHeader: [
		{ text: '업무 ID', headerKey: 'code' },
		{ text: '상태', headerKey: 'status', type: 'status' },
		{ text: '고객사', headerKey: 'client', type: 'name' },
		{ text: '업무 등록일', headerKey: 'createDatetime', type: 'date' },
		{ text: '시험 종료일', headerKey: 'endDatetime', type: 'date' },
		{
			text: '최근 수정일시',
			headerKey: 'recentlyWorkDatetime',
			type: 'date'
		},
		{ text: '마지막 수정 내용', headerKey: 'content' }
	],
	//업무 페이지 - 리스트
	workTableHeader: [
		{ text: '업무 ID', headerKey: 'code' },
		{ text: '상태', headerKey: 'status', type: 'status' },
		{ text: '고객사 이름', headerKey: 'client', type: 'name' },
		{ text: '담당자', headerKey: 'assignee' },
		{ text: '구분', headerKey: 'classification' },
		{ text: '의뢰일', headerKey: 'startDatetime', type: 'date' },
		{ text: '종료예정일', headerKey: 'endDatetime', type: 'date' },
		{ text: '담당부서', headerKey: 'department' },
		{ text: '의뢰담당자', headerKey: 'assigneeResearcher' },
		{ text: '시험부서', headerKey: 'researchDepartment' },
		{ text: '분석 항목 수', headerKey: 'count' },
		{ text: '용도', headerKey: 'purpose' },
		{ text: '특이사항', headerKey: 'memo' },
		{ text: '채취 장소', headerKey: 'location' },
		{ text: '최근업무', headerKey: 'recentlyWork' },
		{
			text: '최근 업무 진행일',
			headerKey: 'recentlyWorkDatetime',
			type: 'date'
		}
	],
	//업무 이력
	workHistoryTableHeader: [
		{
			text: '업무 ID',
			headerKey: 'code',
			link: { targetKey: 'id', type: 'project' }
		},
		{
			text: '시작일',
			headerKey: 'startDatetime',
			type: 'date',
			isSort: true
		},
		{ text: '시험 종료일', headerKey: 'endDatetime', type: 'date' },
		{ text: '상태', headerKey: 'status' },
		{ text: '검사 수수료', headerKey: 'amount', type: 'num' },
		{
			text: '정산',
			headerKey: 'isSettle'
		}
	],

	/**
	 * 업무 상세 - 정산내역.
	 * headerKey 는 서버 정렬 화이트리스트(routes/v1/project/settle.js SORTABLE)의 키와
	 * 같아야 한다 — 다르면 정렬이 조용히 기본값(id)으로 떨어진다.
	 */
	accountHistoryTableHeader: [
		// { text: 'NO', headerKey: 'id'},
		{ text: '정산요청일자', headerKey: 'transactDate', type: 'date', isSort: true },
		{ text: '발행/입금일자', headerKey: 'settlementDate', type: 'date', isSort: true },
		{ text: '정산 종류', headerKey: 'category', type: 'type', isSort: true },
		{ text: '발행 종류', headerKey: 'type', type: 'type', isSort: true },
		{ text: '고객사', headerKey: 'client.name', isSort: true },
		{ text: '발행금액', headerKey: 'publishedAmount', type: 'amount', isSort: true },
		// { text: '품목명', headerKey: 'product.name' },
		{ text: '입금금액', headerKey: 'amount', type: 'amount', isSort: true },
		{ text: '비고', headerKey: 'memo', isSort: true },
	],
	//업무 상세 - 시험 정보 - 시료별 보기
	testInfoTableHeaders: [
		{ text: '시료번호', headerKey: 'sampleNo', type: 'id' },
		{ text: '시료이름', headerKey: 'sampleName', type: 'id' },
		{ text: '진행률', headerKey: 'testCategoryProgress', type: 'process' },
		// { text: '채취 장소', headerKey: 'sampleCollectPoint' },
		// { text: '채취 지점', headerKey: 'additional.soil_area', type: 'additional'},
		{
			text: '채취 심도',
			headerKey: 'additional.soil_depth',
			type: 'additional'
		},
		// { text: '시험 방법', headerKey: 'testWay' }
	],
	//업무 상세 - 시험 정보 - 시험항목별 보기
	categoryTestInfoTableHeaders: [
		{
			text: '시험항목',
			headerKey: 'testGroup.testCategoryName',
			type: 'row'
		},
		{
			text: '시험일지',
			headerKey: 'testGroup.testCategoryTestReportUrl',
			type: 'button'
		},
		{
			text: '진행률',
			headerKey: 'testGroup.testCategoryProgress',
			type: 'process'
		},
		{ text: '시료번호', headerKey: 'sampleNo', type: 'id' },
		{ text: '시험 방법', headerKey: 'testWay' },
		{ text: '시험 결과', headerKey: 'testResult', type: 'result' }
	],
	//업무 상세 - 시험일지 작성 - 사용기기
	useDeviceTableHeader: [
		{ text: '조작 조건', headerKey: 'condition' },
		{ text: '값', headerKey: 'value' }
	],
	//업무 상세 - 시험일지 작성 - 1차 표준물질
	firstStandardTableHeader: [
		{ text: '항목', headerKey: 'name' },
		{ text: '농도', headerKey: 'concentration' },
		{ text: '제조사', headerKey: 'maker' },
		{ text: '관리번호', headerKey: 'mngCode' },
		{ text: 'Lot#', headerKey: 'lotno' },
		{ text: '개봉일자', headerKey: 'opneDate' },
		{ text: '유효일', headerKey: 'validDate' },
		{ text: '조제일자', headerKey: 'makeDate' },
		{ text: '표준 사용량', headerKey: 'stdUseVolume' },
		{ text: '최종 부피', headerKey: 'lastVolime' }
	],
	//업무 상세 - 시험일지 작성 - 2차 표준물질
	secondStandardTableHeader: [
		{ text: '조제일자', headerKey: 'name' },
		{ text: '항목', headerKey: 'makeDate' },
		{ text: 'std1', headerKey: 'std1' },
		{ text: 'std2', headerKey: 'std2' },
		{ text: 'std3', headerKey: 'std3' },
		{ text: 'std4', headerKey: 'std4' }
	],
	//업무 상세 - 시험일지 작성 - 사용시약
	useReagentTableHeader: [
		{ text: '조제일자', headerKey: 'makeDate' },
		{ text: '시약명', headerKey: 'name' },
		{ text: '취급 시 특이사항', headerKey: 'cautionText' }
	],
	//업무 상세 - 시험일지 작성 - 작업 물질 검정 (Abs, 흡광도, 농도 등)
	testingSubstanceTableHeader: [
		{ text: '항목', headerKey: 'name' },
		{ text: 'std1', headerKey: 'std1' },
		{ text: 'std2', headerKey: 'std2' },
		{ text: 'std3', headerKey: 'std3' },
		{ text: 'std4', headerKey: 'std4' }
	],
	//업무 상세 - 시험일지 작성 - 시험분석결과
	analysisResultTableHeader: [
		{ text: '시료명', headerKey: 'sampleName' },
		{ text: '시험항목', headerKey: 'testCategory' },
		{ text: '시료 농도', headerKey: 'reagentConcentration' },
		{ text: '바탕 시료 농도', headerKey: 'backgroundConcentration' },
		{ text: '희석 배수', headerKey: 'dilutionFactor' },
		{ text: '최종 농도', headerKey: 'lastConcentration' },
		{ text: '표시 농도', headerKey: 'markedConcentration' }
	],
	//업무 상세 - 시험일지 작성 - CCV
	ccvTableHeader: [
		{ text: 'CCV 날짜', headerKey: 'date' },
		{ text: '시험항목', headerKey: 'name' },
		{ text: 'Blank (mg/L)', headerKey: 'blank' },
		{ text: 'CCV 지시값 (mg/L)', headerKey: 'indicationValue' },
		{ text: 'CCV 측정값 (mg/L)', headerKey: 'measuresedValue' },
		{ text: '회수율', headerKey: 'recoveryValue' }
	],

	//업무 상세 - 시료 등록하기 - 시험정보- 기본(폐기물·대기 등: 시료채취시간 없음)
	workTestDefaultHeaders: [
		{ text: '시료번호', headerKey: 'no' },
		{ text: '시료명', headerKey: 'name' }
	],
	//업무 상세 - 시료 등록하기 - 시험정보- 수질
	workTestCategoryHeaders: [
		{ text: '시료번호', headerKey: 'no' },
		{ text: '시료명', headerKey: 'name' },
		{ text: '시료채취시간(1)', headerKey: 'sampleCollectTime1' },
		{ text: '시료채취시간(2)', headerKey: 'sampleCollectTime2' },
		// { text: '채취 지점', headerKey: 'point' },
		// { text: '토양 채취 심도', headerKey: 'soilDepth'},
		// { text: '토양 지역', headerKey: 'soilArea'},
		// { text: '시험 방법', headerKey: 'testMethod', type: 'select' },
		// {
		// 	text: '추가 시험 방법',
		// 	headerKey: 'secondTestMethod',
		// 	type: 'select'
		// }
	],
//업무 상세 - 시료 등록하기 - 시험정보- 토양 (아래 수질 있음)
	workTestSoilHeaders: [
		{ text: '시료번호', headerKey: 'no' },
		{ text: '시료명', headerKey: 'name' },
		// { text: '채취 지점', headerKey: 'point' },
		{ text: '토양 채취 심도', headerKey: 'soilDepth' },
		// { text: '토양 지역', headerKey: 'soilArea'},
		// { text: '시험 방법', headerKey: 'testMethod', type: 'select' },
		// {
		// 	text: '추가 시험 방법',
		// 	headerKey: 'secondTestMethod',
		// 	type: 'select'
		// }
	],

	//시험 분석 리스트
	analysisTableHeader: [
		{ text: '시료 ID', headerKey: 'analysisId' },
		{ text: '업무 ID', headerKey: 'workId' },
		{ text: '고객사', headerKey: 'client' },
		{ text: '분석항목', headerKey: 'classification' },
		{ text: '특이사항', headerKey: 'memo' },
		{ text: '시험 종료일', headerKey: 'endDatetime' },
		{ text: '분석완료일시', headerKey: 'anaylsisDatetime' },
		{
			text: '기술책임자 승인',
			headerKey: 'approvalStatus',
			type: 'approvalStatus'
		},
		{ text: '상태', headerKey: 'status', type: 'changeStatus' }
	],
	//멤버 리스트
	memberTableHeader: [
		{ text: 'id', headerKey: 'id', type: 'checkbox' },
		{ text: '이름', headerKey: 'name' },
		{ text: '이메일', headerKey: 'email' },
		{ text: '연락처', headerKey: 'phone', type: 'phone' },
		{ text: '부서', headerKey: 'department' },
		{ text: '역할', headerKey: 'position' },
		{ text: '마지막 접속일시', headerKey: 'accessDatetime', type: 'date' },
		{ text: '관리', headerKey: 'edit', type: 'button' }
	],
	//시험 결과 확인 샘플
	confirmResultTableHeader: [
		{ text: '항목', headerKey: 'category', rowspan: 2 },
		{ text: '단위', headerKey: 'unit', rowspan: 2 },
		{
			text: '측정분석방법',
			headerKey: 'methods',
			sub: [
				{ text: '분석방법', headerKey: 'method' },
				{ text: '측정기기', headerKey: 'device' }
			]
		},
		{
			text: '검체명',
			headerKey: 'name',
			sub: [
				{ text: 'item1', headerKey: 'item1', rowspan: 2 },
				{ text: 'item2', headerKey: 'item2', rowspan: 2 },
				{ text: 'item3', headerKey: 'item3', rowspan: 2 },
				{ text: 'item4', headerKey: 'item4', rowspan: 2 }
			]
		}
	],

	/**
	 * 업무상세 - 산출문서 - 시험 의뢰서
	 * No 는 DB id 가 아니라 **화면 표시용 순번**(displayNo)이다.
	 * 종전에는 id 를 그대로 찍어 4338·18999 같은 내부 번호가 사용자에게 노출됐다
	 * (2026-08-21 현업 신고 3-4). 순번은 스토어에서 목록 순서대로 매긴다.
	 */
	testRequestTableHeader: [
		{ text: 'No', headerKey: 'displayNo' },
		{ text: '파일명', headerKey: 'fileName' },
		{ text: '발행일', headerKey: 'createDatetime', type: 'date' },
		{ text: '발행자', headerKey: 'userId' },
		{ text: '다운로드', headerKey: 'download', type: 'button' },
		{ text: '삭제', headerKey: 'delete', type: 'button' }
	],

	//업무상세 - 산출문서 - 시험일지 (No = 표시용 순번, 위 주석 참조)
	testResultTableHeader: [
		{ text: 'No', headerKey: 'displayNo' },
		{ text: '파일명', headerKey: 'fileName' },
		{ text: '시험 항목', headerKey: 'testName' },
		{ text: '발행일', headerKey: 'createDatetime', type: 'date' },
		{ text: '다운로드', headerKey: 'download', type: 'button' },
		{ text: '삭제', headerKey: 'delete', type: 'button' }
	],

	//업무상세 - 산출문서 - 시험성적서
	testReportTableHeader: [
		{ text: 'No', headerKey: 'no' },
		{ text: '파일명', headerKey: 'name' },
		{ text: '설명', headerKey: 'description' },
		{ text: '발행일', headerKey: 'datetime' },
		{ text: '시험 담당자', headerKey: 'maker' },
		{ text: '다운로드', headerKey: 'download' },
		{ text: '삭제', headerKey: 'delete', type: 'button' }
	],
	// 업무상세 - 산출문서 - 시험성적서 (No = 표시용 순번, 위 주석 참조)
	documentTableHeader: [
		{ text: 'No', headerKey: 'displayNo' },
		{ text: '파일명', headerKey: 'filename' },
		{ text: '발행자', headerKey: 'userName' },
		{ text: '발행일', headerKey: 'createDatetime', type: 'date' },
		{ text: '다운로드', headerKey: 'download', type: 'button' },
		{ text: '삭제', headerKey: 'delete', type: 'button' }
	],
	//시료 등록 / 수정 시 기준 옵션 지정
	waterCriteriaTableHeader: [
		{ text: '시험항목', key: 'name', type: 'text' },
		{ text: '기준1', key: 'criteria1', type: 'input' },
		{ text: '기준2', key: 'criteria2', type: 'input' },
		{ text: '기준3', key: 'criteria3', type: 'input' },
		{ text: '기준4', key: 'criteria4', type: 'input' }
	],
	//항목 정보 입력 - 자리수, 기본값, unit, formula
	formDataInfoTableHeader: [
		{ text: '시험필드', key: 'name', type: 'input' },
		{ text: 'KEY', key: 'key', type: 'input' },
		{ text: '변수TYPE', key: 'fieldType', type: 'input' },
		{ text: '기본값', key: 'default', type: 'input' },
		{ text: '단위', key: 'unit', type: 'input' },
		{ text: '자리수', key: 'digit', type: 'input', isSubCategory: true },
		{ text: '계산식', key: 'formula', type: 'input' },
		{ text: '계산식2(후처리)', key: 'formula2', type: 'input' },
		// 시험일지 그리드에서만 숨김(값·계산식은 유지). form_data 항목의 isHide 로 저장됨
		{ text: '일지숨김', key: 'isHide', type: 'switch' }
	],
	//시험분석항목 header
	analysisInfoTableHeader: [
		{ text: '필드 이름', key: 'name', type: 'input' },
		{ text: '엑셀 병합 자리', key: 'col', type: 'input' },
		{ text: 'KEY', key: 'key', type: 'input' }
	],
	//사용기기 기본 정보 header (name, maker) — 행 순서=사용기기①·②
	machineInfoTableHeader: [
		{ text: '기기 이름(모델명)', key: 'name', type: 'input' },
		{ text: '기기 제조사', key: 'maker', type: 'input' }
	],
	//사용기기 header
	machineTableHeader: [
		{ text: '조작조건이름', key: 'condition', type: 'input' },
		{ text: '조작조건값', key: 'value', type: 'input' }
	],
	//사용시약 header
	reagentTableHeader: [
		{ text: '제조일자', key: 'makeDate', type: 'input' },
		{ text: '시약명', key: 'name', type: 'input' },
		{ text: '취급시 특이사항', key: 'cautionText', type: 'input' }
	],
	//optionalForm header
	optionalFormTableHeader: [
		{ text: '시험필드', key: 'text', type: 'input' },
		{ text: 'KEY', key: 'key', type: 'input' },
		{ text: '변수TYPE', key: 'fieldType', type: 'input' },
		{ text: '기본값', key: 'default', type: 'input' },
		{ text: '단위', key: 'unit', type: 'input' },
		{ text: '자리수', key: 'digit', type: 'input' },
		
	],
	subCategoryTableHeader: [
		{ text: '시험필드', key: 'name', type: 'input' },
		{ text: '변수TYPE', key: 'fieldType', type: 'input' },
		{ text: '기본값', key: 'default', type: 'input' },
		{ text: '단위', key: 'unit', type: 'input' },
		{ text: '자리수', key: 'digit', type: 'input' },
		{ text: '계산식', key: 'formula', type: 'input' }
	],
	stdMaterialTableHeader: [
		{ text: '항목', key: 'name', type: 'input' },
		{ text: '농도', key: 'concentration', type: 'input' },
		{ text: '제조사', key: 'maker', type: 'input' },
		{ text: '관리번호', key: 'mngCode', type: 'input' },
		{ text: 'Lot#', key: 'lotno', type: 'input' },
		{ text: '개봉일자', key: 'openDate', type: 'input' },
		{ text: '유효일', key: 'validDate', type: 'input' },
		{ text: '조제일자', key: 'makeDate', type: 'input' },
	],
	taskStdMaterialTableHeader: [
		{ text: '항목', key: 'name', type: 'input' },
		{ text: '조제일자', key: 'makeDate', type: 'input' },
		{ text: '표준 사용량', key: 'stdUseVolume', type: 'input' },
		{ text: '최종 부피', key: 'lastVolime', type: 'input' },
		{ text: '농도', key: 'concentration', type: 'input' },
		{ text: '2차 조제일자', key: 'makeDate2', type: 'input' },
		{ text: 'std1', key: 'std1', type: 'input' },
		{ text: 'std2', key: 'std2', type: 'input' },
		{ text: 'std3', key: 'std3', type: 'input' },
		{ text: 'std4', key: 'std4', type: 'input' },
		{ text: 'std5', key: 'std5', type: 'input' },
	],
	clientSpecimenTableHeader: [
		{ text: '구분', key: 'sourceLabel' },
		{ text: '업무 분류', key: 'categoryLabel' },
		{ text: '시료이름', key: 'name' },
		{ text: '시험방법', key: 'testMethod' },
		{ text: '추가시험방법', key: 'secondTestMethod' },
		{ text: '시험항목', key: 'testCategory' },
		{ text: '복제', key: 'copy', type: 'button' },
		{ text: '수정', key: 'edit', type: 'button' },
		{ text: '삭제', key: 'delete', type: 'button' }
	],
	clientSpecimenStandardTableHeader: [
		{ text: '시험항목 이름', key: 'name' },
		{
			text: '',
			key: 'col_1',
			type: 'search',
			placeholder: '기준을 선택해주세요',
			groupKey: ''
		},
		{
			text: '',
			key: 'col_2',
			type: 'search',
			placeholder: '기준을 선택해주세요',
			groupKey: ''
		},
		{
			text: '',
			key: 'col_3',
			type: 'search',
			placeholder: '기준을 선택해주세요',
			groupKey: ''
		},
		{
			text: '',
			key: 'col_4',
			type: 'search',
			placeholder: '기준을 선택해주세요',
			groupKey: ''
		}
	],
	//정산 - 이슈보드
	/**
	 * 정산 이슈보드(발행·입금 탭) 표 컬럼.
	 *
	 * 2026-08-20 현업 요청(2-1-1·2-2-1)으로 «접수번호·분류·내용» 3칸이던 것을
	 * 용역명·접수고객사·회계고객사까지 펼쳤다. 담당자·일시 라벨은 탭마다 다르다.
	 *   발행탭: 요청자 / 발행자 / 발행일자
	 *   입금탭: 입력자 / 확인자 / 입금일자
	 * 사람·날짜 컬럼의 **데이터 키는 같고 라벨만 바뀐다** (user_id·reviewer_id·settlementDate).
	 *
	 * 발행일자/입금일자(`settlementDate`)는 서버가 같은 정산 배치·업무의 정산 행 settlement_date 를
	 * 내려주는 값으로, 정산 등록 상세 모달·업무 정산 내역의 «발행일자/입금일자» 와 같다 (2026-09-10
	 * 현업 2-1·2-2). 종전에는 이슈 등록 시각 `createDatetime` 을 «발행일시» 로 시·분까지 보여 상세와
	 * 달랐다. `createDatetime` 은 응답에 남아 «신규(N)» 판정에만 쓴다.
	 *
	 * «분류·내용» 은 뺐다 (2026-08-25 현업 피드백).
	 *   분류: 탭이 곧 분류다. 목록 조회가 항상 category=PUBLISH|PAID 로 좁혀지므로
	 *         («stores/settlement/list.js» loadIssueList) 한 탭에 두 분류가 섞이지 않는다.
	 *   내용: "접수번호 : … 을 발행 처리하였습니다. 발행금액은 N원 입니다." 문장이라
	 *         분류·접수번호가 옆 칸과 겹쳤다. 실제로 필요한 건 금액뿐이라 금액 열로 바꿨다.
	 * 금액은 문장을 파싱하지 않고 서버가 project_account_settlement 에서 집계해 내려준다.
	 *
	 * 정렬(isSort): 모든 열 정렬 가능 (2026-09-21 복구). key 는 서버 routes/v1/settle/index.js 의
	 * SORT_KEYS_ISSUE(ISSUE_BASE_SELECT 별칭)와 같아야 한다 — 다르면 서버가 기본 정렬로 조용히 떨어진다.
	 * 종전에는 이 표에 정렬이 없었다 (서버 ORDER BY pai.id 고정).
	 */
	settlementIssueBaseHeader: [
		{
			label: '접수번호',
			key: 'projectCode',
			link: { targetKey: 'projectCode', type: 'project' },
			isSort: true
		},
		{ label: '용역명', key: 'projectTitle', isSort: true },
		{ label: '접수고객사', key: 'clientName', isSort: true },
		{ label: '회계고객사', key: 'accountClientName', isSort: true },
		{ label: '금액', key: 'amount', type: 'amount', isSort: true },
	],
	/** 발행탭 전용 꼬리 컬럼 */
	settlementIssuePublishTail: [
		{ label: '요청자', key: 'userName', isSort: true },
		{ label: '발행자', key: 'reviewerName', isSort: true },
		{ label: '발행일자', key: 'settlementDate', type: 'date', isSort: true },
		{ label: '작업상태', key: 'status', type: 'select-status', isSort: true },
	],
	/** 입금탭 전용 꼬리 컬럼 */
	settlementIssuePaidTail: [
		{ label: '입력자', key: 'userName', isSort: true },
		{ label: '확인자', key: 'reviewerName', isSort: true },
		{ label: '입금일자', key: 'settlementDate', type: 'date', isSort: true },
		{ label: '작업상태', key: 'status', type: 'select-status', isSort: true },
	],
	/**
	 * 정산 - 내역 (정산예정·정산완료 탭).
	 *
	 * 정렬(isSort): 전체 선택을 뺀 9개 열 모두 정렬 가능 (2026-09-21 복구).
	 * 2026-08-24 공통 표가 «isSort 있는 열만 클릭» 으로 바뀌면서 용역명만 남았었다.
	 * key 는 서버 routes/v1/settle/index.js 의 SORT_KEYS_SETTLE 과 맞아야 하며, 중첩 key
	 * (client.name·accountClient.name)는 서버 SETTLE_SORT_ALIAS 가 SQL 별칭으로 바꾼다.
	 * 미발행금액은 서버 SQL 에도 같은 정의(계약금액 - 발행금액)의 별칭을 두어 정렬한다.
	 */
	settlementListTableHeader: [
		{ key: 'selected', label: '전체 선택' },
		{ label: '접수번호', key: 'code', link: { "targetKey": "code", "type": "project" }, isSort: true },
		{ label: '용역명', key: 'title', isSort: true },
		{ label: '접수고객사', key: 'client.name', type: 'client', link: { "targetKey": "clientId", "type": "client" }, isSort: true },
		{ label: '회계고객사', key: 'accountClient.name', type: 'client', link: { "targetKey": "clientId", "type": "client" }, isSort: true },
		{ label: '계약금액', key: 'totalAmount', type: 'amount', isSort: true },
		{ label: '발행금액', key: 'publishedAmount', type: 'amount', isSort: true },
		{ label: '미발행금액', key: 'unpublishedAmount', type: 'amount', isSort: true },
		{ label: '입금금액', key: 'amount', type: 'amount', isSort: true },
		{ label: '미수금액', key: 'unpaidAmount', type: 'amount', isSort: true },
	]
}

export default tableHeaders
